const DEFAULT_EMPTY_COLOR = "#FFFFFF";

const hexToRgb = color => {
  const hex = color?.replace("#", "");

  if (!hex || ![3, 6].includes(hex.length)) return null;

  const normalized = hex.length === 3
    ? hex.split("").map(value => value + value).join("")
    : hex;
  const value = parseInt(normalized, 16);

  return {
    r: (value >> 16) & 255,
    g: (value >> 8) & 255,
    b: value & 255,
  };
};

const mixColors = (startColor, endColor, percentage) => {
  const start = hexToRgb(startColor);
  const end = hexToRgb(endColor);

  if (!start || !end) return startColor || endColor || DEFAULT_EMPTY_COLOR;

  const mixChannel = (startValue, endValue) => (
    Math.round(startValue + ((endValue - startValue) * percentage))
  );

  return `rgb(${mixChannel(start.r, end.r)}, ${mixChannel(start.g, end.g)}, ${mixChannel(start.b, end.b)})`;
};

export const getHeatmapColor = (value, colorRange, legendRange) => {
  const number = Number(value);
  const min = Number(legendRange?.min);
  const max = Number(legendRange?.max);

  if (value === null || value === undefined || !Number.isFinite(number)) {
    return DEFAULT_EMPTY_COLOR;
  }

  if (!Array.isArray(colorRange) || colorRange.length === 0) {
    return DEFAULT_EMPTY_COLOR;
  }

  if (colorRange.length === 1 || !Number.isFinite(min) || !Number.isFinite(max) || min === max) {
    return colorRange[0];
  }

  if (number <= min) { return colorRange[0];}
  if (number >= max) { return colorRange[colorRange.length - 1]; }

  const boundedValue = Math.min(Math.max(number, min), max);
  const scalePosition = (boundedValue - min) / (max - min);
  const segmentCount = colorRange.length - 1;
  const scaledIndex = scalePosition * segmentCount;
  const startIndex = Math.min(Math.floor(scaledIndex), segmentCount - 1);
  const endIndex = startIndex + 1;
  const segmentPercentage = scaledIndex - startIndex;

  return mixColors(colorRange[startIndex], colorRange[endIndex], segmentPercentage);
};
